module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img.47181295.jpeg";